import React, { PureComponent } from "react";
import { View, Text, StyleSheet } from "react-native";

import { Arrow } from "emrn-design/Arrow";
import { EmTouchableWithoutFeedback } from "emrn-design/EmTouchable";

export class TitleBar extends PureComponent<{
  title: string;
  onBack?: () => void;
  onCancel: () => void;
}> {
  render() {
    const { title, onBack, onCancel } = this.props;
    return (
      <View style={styles.container}>
        {!onBack ? (
          <View style={styles.sibling} />
        ) : (
          <EmTouchableWithoutFeedback onPress={onBack}>
            <View style={styles.sibling}>
              <Arrow direction="left" size={10} color="#666" />
            </View>
          </EmTouchableWithoutFeedback>
        )}
        <Text style={styles.title}>{title}</Text>
        <EmTouchableWithoutFeedback onPress={onCancel}>
          <View style={styles.sibling}>
            <View style={styles.close}>
              <View
                style={[
                  styles.close_1ine,
                  { transform: [{ rotate: "-45deg" }] },
                ]}
              />
              <View
                style={[
                  styles.close_1ine,
                  { transform: [{ translateY: -1 }, { rotate: "45deg" }] },
                ]}
              />
            </View>
          </View>
        </EmTouchableWithoutFeedback>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: "#eee",
    borderBottomWidth: 1,
  },
  title: {
    color: "#333",
    fontSize: 15,
    fontWeight: "500",
  },
  sibling: {
    width: 50,
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  close: {
    alignItems: "center",
    justifyContent: "center",
  },
  close_1ine: {
    width: 16,
    height: 1,
    backgroundColor: "#666",
    justifyContent: "center",
  },
});
